import useDesignTemplates from "hooks/useDesignTemplates";
import _ from "lodash";
import { useMemo } from "react";
export type TemplateCounts = {
  [themeName: string]: number;
};

const useTemplateCounts = () => {
  const { templates, isLoading, error } = useDesignTemplates();

  const templateCounts = useMemo(() => {
    if (isLoading || error || !templates) {
      return {};
    }

    const groupedByTheme = _.groupBy(templates, (t) => t.theme);

    const counts: TemplateCounts = _.mapValues(
      groupedByTheme,
      (templatesInGroup) => templatesInGroup.length
    );

    return counts;
  }, [templates, isLoading, error]);

  return { templateCounts, isLoading, error };
};

export default useTemplateCounts;
